import React from "react";
import newsletters from "../css/newsletters.css";

const NewsLetters = () => {
  return (
    <div style={newsletters} className="newsletters">
      <h1>Never miss our Exclusive offers</h1>
      <p>Subcribe to our Newsletter to stay updated</p>
      <div>
        <input type="email" placeholder="Enter your email..." />
        <button>Subscribe</button>
      </div>
    </div>
  );
};

export default NewsLetters;
